

import Component from 'generic.basecomponent';
import createEvent from 'create-event';
import constants from 'general/js/constants';

export default class Spinbox extends Component {
    constructor(el) {
        super(el);
        this.container = el;
        this.onIncrease = this.onIncrease.bind(this);
        this.onDiscrease = this.onDiscrease.bind(this);
        this.defineVariables();
        this.init();
    }

    defineVariables() {
        this.input = this.container.querySelector('.js-spinbox-input');
        this.discrease = this.container.querySelector('.js-spinbox-discrease');
        this.increase = this.container.querySelector('.js-spinbox-increase');
        this.maxValue = parseInt(this.container.getAttribute('data-spinbox-max'), 10);
        const minAttr = this.container.getAttribute('data-spinbox-min');
        this.minValue = (minAttr === null) ? 1 : parseInt(minAttr, 10);
    }

    init() {
        this.increase.addEventListener('click', this.onIncrease);
        this.discrease.addEventListener('click', this.onDiscrease);
    }

    onIncrease(e) {
        e.preventDefault();
        if ((!Number.isNaN(this.maxValue) && this.maxValue > this.input.value) || (Number.isNaN(this.maxValue))) {
            this.input.value++;
            this.triggerChange();
        }
    }

    onDiscrease(e) {
        e.preventDefault();
        if (this.input.value > this.minValue) {
            this.input.value--;
            this.triggerChange();
        }
    }

    triggerChange() {
        this.input.dispatchEvent(createEvent('input'));
        this.input.dispatchEvent(createEvent('change'));

        this.input.dispatchEvent(createEvent(constants.EVENT_SPINBOX_CHANGED));
    }

    setToMin() {
        this.input.value = this.minValue;
        this.triggerChange();
    }

    disable() {
        this.input.setAttribute('disabled', '');
    }

    enable() {
        this.input.removeAttribute('disabled');
    }

    destroy() {
        super.destroy();
        this.increase.removeEventListener('click', this.onIncrease);
        this.discrease.removeEventListener('click', this.onDiscrease);
        this.container.classList.remove('js-spinbox-inited');
    }

    getValue() {
        return this.input.value;
    }
}
Spinbox.id = 0;



// WEBPACK FOOTER //
// ./app/components/spinbox/js/generic.spinbox.js